import * as React from "react";
import Modal from "./modal";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import Mail from "./mail";
import Phone from "./phone";
import Link from "./link";
import { FormattedMessage } from "react-intl";

const QuestionModal = ({
  isOpen,
  onClose,
  triggerRef,
  renderOptions,
  modalLevels,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      triggerRef={triggerRef}
      variant="default"
    >
      <div className="modal-text">
        {modalLevels && renderRichText(modalLevels, renderOptions)}
        <div className="booking-contact-actions">
          <p>
            <FormattedMessage id="contactSectionTitle" />
          </p>
          <div className="booking-contact booking-contact-mail">
            <Mail />{" "}
            <Link href="/contact">
              <FormattedMessage id="contactSectionEmail" />
            </Link>
          </div>
          <div className="booking-contact booking-contact-phone">
            <Phone />
            <Link href="tel:+33189315582">
              <FormattedMessage id="contactSectionPhone" />
            </Link>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default QuestionModal;
